import React, { useEffect, useState } from "react";
import "./chats.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../app/Api/ApiSlice";
import { toast } from "react-toastify";
import socket from "../../sockets";
import UserConversation from "../../components/UserConversation"
import { useSelector } from "react-redux";
import { FaInbox } from "react-icons/fa";
import Loader from "../../components/Loader";
import { selectCurrentUser } from "../../app/selectors/authSelectors";


// this is for users to see chats they have made with other users,organizations or businesses
const Chats = () => {
    const user = useSelector(selectCurrentUser);
    const navigate = useNavigate();

    const [chats, setChats] = useState([]);
    const [isLoading,setIsLoading] = useState(false)


    /* ---------------- SOCKET SETUP ---------------- */

    useEffect(() => {
        const onConnect = () => {
            // useful for debugging; keep quiet in production
            if (process.env.NODE_ENV !== "production") {
                console.log("Socket connected:", socket.id);
            }
        };
        socket.on("connect", onConnect);

        // return () => {
        //     socket.disconnect();
        // };
        return () => socket.off("connect", onConnect);
    }, []);



    useEffect(() => {
        const fetchChats = async () => {
            setIsLoading(true)
            try {
                const res = await api.get("/chats");
                setIsLoading(false)
                setChats(res.data);
            } catch {
                setIsLoading(false)
                toast.error("Failed to load chats");
            }
        };

        fetchChats();
    }, []);

    // console.log(chats)

    return (
        <div className="page-body chats-page">
            <div className="chats-layout">
                <div className="chats-">
                    <div className="chats-header">
                        <h3 className="chats-title">Chats</h3>
                        <button
                            className="new-chat-btn"
                            onClick={() => navigate("/chats/friends")}
                        >
                            <FaInbox />
                            <span>New</span>
                        </button>
                    </div>

                    <input
                        className="chat-search"
                        placeholder="Search conversations"
                    />

                    <nav className="chat-list">
                        {isLoading && <Loader/>}
                        {!isLoading && !chats.length && <p>No chats found</p>}
                        {chats.map((chat) => (
                            <UserConversation conversation={chat} key={chat._id}/>
                        ))}

                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Chats;
